module.exports = __webpack_public_path__ + "static/img/HA_H5.c4d50ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HA_H5.png
// module id = 8Lpi
// module chunks = 34